import TableDefinitions from '../../../../../common/TableDefinitions';

export const getSaveRequestResponse = (state) => state.denestImpc.saveRequestResponse;
export const getIsLoading = (state) => state.listing.MRD_DENEST_IMPC_MAPPING.isLoading;
export const getCheckboxSelections = (state) => state.listing.MRD_DENEST_IMPC_MAPPING.checkboxSelections;
export const getData = TableDefinitions.MRD_DENEST_IMPC_MAPPING.getDataFunction();
